export default class Events {
    static APIError: string = "APIError"
    static APIErrorHide: string = "APIErrorHide"
    static Notification: string = "Notification"
    static OrderTaskNotification: string = "OrderTaskNotification"
    static UpdateUserData: string = "UpdateUserData"
}
